export interface PasswordResetTokenInterface {
  userId: string;
  resetToken: string;
}

export class PasswordResetToken implements PasswordResetTokenInterface {
  public userId: string;
  public resetToken: string;

  constructor(userId: string, resetToken: string) {
    this.userId = userId;
    this.resetToken = resetToken;
  }
}
